import {
  Alert,
  AlertTitle,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Family, FamilyStatus } from "../../protogen/advisors_service_pb";
import ActivationDialog from "../family/ActivationDialog";
import { Box } from "@mui/system";
import useIsMobile from "../hooks/useIsMobile";
import CloseIcon from "@mui/icons-material/Close";

const PreactivatedContent = ({ family }: { family: Family }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <AlertTitle sx={{ fontWeight: "bold", mb: "8px", color: "#198282" }}>
        Billing not yet started
      </AlertTitle>
      <Typography sx={{ color: "#198282" }}>
        Start service to begin billing and tracking time spent on tasks.
      </Typography>
      <Box sx={{ height: "0px !important", overflow: "hidden" }}>
        This is a bunch of filler text to push the width to full width, but
        won't up and take up space in the UI. We are doing this because we
        absolute positioned it.
      </Box>
      <Box display="flex" flexDirection="row">
        <Button onClick={() => setOpen(true)} size="small" sx={{ mt: 2 }}>
          Start service
        </Button>
      </Box>
      <ActivationDialog family={family} open={open} setOpen={setOpen} />
    </>
  );
};

const ProspectContent = () => {
  return (
    <>
      <AlertTitle
        sx={{
          fontWeight: "bold",
          mb: "8px",
          color: "#B85700",
        }}
      >
        This family hasn’t finished signing up
      </AlertTitle>
      <Box sx={{ height: "0px !important", overflow: "hidden" }}>
        This is a bunch of filler text to push the width to full width, but
        won't up and take up space in the UI. We are doing this because we
        absolute positioned it.
      </Box>
      <Typography sx={{ color: "#B85700" }}>
        Encourage them to finish their onboarding profile before starting work.
      </Typography>
    </>
  );
};

export default ({ family }: { family: Family }) => {
  const isMobile = useIsMobile();
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) {
    return null;
  }
  let content = null;
  if (family.status === FamilyStatus.PREACTIVATION) {
    content = <PreactivatedContent family={family} />;
  } else if (family.status === FamilyStatus.PROSPECT) {
    content = <ProspectContent />;
  } else {
    return null;
  }
  return (
    <Alert
      severity="warning"
      color="info"
      icon={false}
      sx={{
        margin: "12px 16px",
        borderRadius: "8px",
        position: "absolute",
        top: isMobile ? "185px" : "70px",
        backgroundColor:
          family.status === FamilyStatus.PREACTIVATION ? "#E3EFED" : "#FFF4EA",
      }}
    >
      {content}
      <IconButton
        aria-label="close"
        onClick={() => setDismissed(true)}
        sx={{
          position: "absolute",
          right: 12,
          top: 12,
          color:
            family.status === FamilyStatus.PREACTIVATION
              ? "#198282"
              : "#B85700",
        }}
      >
        <CloseIcon />
      </IconButton>
    </Alert>
  );
};
